<template>
  <b-col class="faq-search-container">
    <Breadcrumbs></Breadcrumbs>
    <b-form @submit.prevent="submit()">
      <h1 class="faq-results-heading">Search Results</h1>
      <b-row class="justify-content-md-center boxes faq-search-form-container">
        <b-col md="6" lg="6" class="pl-sm-0 pr-sm-0">
          <label for="query" v-if="isIE">{{ placeholders.query }}</label>
          <b-input-group label="" label-for="query">
            <div data-for="query" class="placeholder-label">{{ placeholders.query }}</div>
            <b-form-input id="query" type="text" v-model.trim="query" :placeholder="placeholders.query"
                          class="customer">
            </b-form-input>
            <b-input-group-append>
              <b-button block type="button" class="btn btn-default btn-account" variant="primary" @click.prevent.stop="submit()">
                Search
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </b-form>
    <h2 v-if="faqSearchResults.length < 1" class="empty-result-title">No faqs found!</h2>
    <section class="boxes update-back-btn" v-if="faqSearchResults.length < 1">
      <b-row class="justify-content-md-center">
        <b-col md="4">
          <button type="button" @click="goBack()" class="btn-base input-choice-btn new-btn-outline-success stroke-2x">Back</button>
        </b-col>
      </b-row>
    </section>
    <div v-if="faqSearchResults.length > 0" class="faq-questions look-for-your-question">
      <b-row class="justify-content-md-center">
        <b-col class="faq-question-cards">
          <div class="faq-container-first">
            <b-row class="questions justify-content-md-center position-relative zIndex" >
              <b-col v-for="faq in faqSearchResults" :key="'faq-' + faq.id" md='4' class="related-q-p">
                <router-link class="faq-link" :to="{ name: 'faq-details', params: { slug: faq.slug }}" custom>
                  <b-card sub-title="" class="my-faq-card-two rel-faq-card h-100">
                    <b-card-title v-html="getQuestion(faq)"></b-card-title>
                    <b-card-text v-html="getShortAnswer(faq)" class="footer-card-answer">
                    </b-card-text>
                  </b-card>
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-col>
</template>

<script>
import {mapState} from 'vuex'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  name: 'FaqSearch',
  components: {Breadcrumbs},
  metaInfo: function() {
    return {
      title: this.searchedQuery ? `${this.searchedQuery} - Search Results` : 'Faq Search'
    }
  },
  data: function() {
    return {
      placeholders: {
        query: 'Search FAQs',
        searchedQuery: ''
      },
      query: ''
    }
  },
  computed: {
    ...mapState(['isIE', 'faqSearchResults'])
  },
  methods: {
    highlightString: function(target, source) {
      if (!target) {
        return ''
      }
      if (!source) {
        return target
      }
      let startIndex = target.toLowerCase().search(source.toLowerCase())
      if (startIndex < 0) {
        return target
      }
      let endIndex = startIndex + source.length
      let searchedString = target.slice(startIndex, endIndex)
      return target.replace(searchedString, `<span class="search-highlight">${searchedString}</span>`)
    },
    getQuestion: function(faq) {
      return this.highlightString(faq.question, this.searchedQuery)
    },
    getShortAnswer: function(faq) {
      let answer = ''
      if (faq.blurb && faq.blurb.length) {
        answer = faq.blurb
      } else {
        let div = document.createElement('div')
        div.innerHTML = faq.answer
        answer = div.innerText
      }
      return this.highlightString(answer, this.searchedQuery)
    },
    submit: function() {
      this.searchedQuery = this.query
      this.$store.commit('busy')
      this.$store.dispatch('set_session_started')
      this.$store.dispatch('initiate_faq_search', {q: this.query})
        .then(_result => {
          this.$store.commit('ready')
        })
        .catch(err => {
          if (err.response.status === 303 && err.response.data) {
            this.$store.commit('session', err.response.data)
          }
          this.$router.replace('/session')
        })
    },
    goBack: function() {
      this.$router.go(-1)
    }
  },
  created() {
    this.query = decodeURIComponent(this.$route.query.q)
    this.submit()
  }
}
</script>

<style scoped lang="less">
  .search-highlight {
    background: var(--theme_color) !important;
    color: #FFFFFF !important;
  }

</style>
